<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    class="chip"
    :class="{
      disabled: disabled,
      'quantity-chip': type === 'quantity',
      'chip-default': variant === 'default',
      'chip-filled': variant === 'filled',
      'chip-filter': variant === 'filter',
      'chip-status': variant === 'status',
      'chip-status-success': type === 'status success',
      'chip-status-warning': type === 'status warning',
      'chip-status-danger': type === 'status danger',
      'chip-status-unpublished': type === 'status unpublished',
      'chip-status-scheduled': type === 'status scheduled',
    }"
    :aria-disabled="disabled ? 'true' : null"
  >
    <span v-if="icon" :class="icon" class="chip-icon"></span>
    <span v-if="type === 'quantity'" class="chip-quantity">{{ quantity }}</span>
    <span v-if="text" class="chip-text">{{ text }}</span>
    <span v-else-if="label" class="chip-label">{{ label }}</span>
    <span
      v-if="removable && !disabled"
      class="chip-remove-icon"
      :class="removeIcon || 'pi pi-times-circle'"
      role="button"
      :aria-label="`Remove ${text || label || 'chip'}`"
      tabindex="0"
      @click.stop="$emit('remove', $event)"
      @keydown.enter.stop="$emit('remove', $event)"
    ></span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    quantity: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
      validator: (value) =>
        [
          "",
          "quantity",
          "status success",
          "status warning",
          "status danger",
          "status unpublished",
          "status scheduled",
        ].includes(value),
    },
    variant: {
      type: String,
      default: "default",
      validator: (value) =>
        ["default", "filled", "filter", "status"].includes(value),
    },
    icon: {
      type: String,
      default: "",
    },
    removable: {
      type: Boolean,
      default: false,
    },
    removeIcon: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    colorNumber: {
      type: Number,
      default: 1,
      validator: (value) => value >= 1 && value <= 5,
    },
  },
  emits: ["remove"],
};
</script>

<style lang="scss" scoped>
.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 12.64px;
  font-family: "Voyado Text";
  font-weight: 500;
  transition: background-color 0.2s, border-color 0.2s, opacity 0.2s;
  // line-height: 1.5;
  gap: 0.5rem;
  max-width: fit-content;
  border: none;
  height: 24px;
}

.chip-default {
  background-color: #f8f9fa;
  color: #222222;
}

.chip-filled {
  background-color: #2d6e6d;
  color: white;
}

.chip-filter {
  background-color: #e9ecef;
  border: 1px solid #222222;
  color: #222222;
}

.chip-status {
  background-color: #d4edda;
  color: #155724;
}

.chip-status-success {
  background-color: #43a584;
  color: #fff;
}

.chip-status-warning {
  background-color: #f9e688;
  color: #21211f;
}

.chip-status-unpublished {
  background-color: #d8d8d5;
  color: #21211f;
}

.chip-status-danger {
  background-color: #bf1100;
  color: #fff;
}

.chip-status-scheduled {
  background-color: #b7e9ff;
  color: #21211f;
}

.chip-quantity {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 5px;
  justify-content: center;
  height: 16px;
  background-color: #2d6e6d;
  color: white;
  font-size: 12.64px;
  font-weight: 400;
  border-radius: 99px;
}

.quantity-chip {
  background-color: #f0f0ef;
}

.chip-text,
.chip-label {
  color: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}

.chip-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  line-height: 1;
}

.chip-remove-icon {
  cursor: pointer;
  margin-left: 0.25rem;
  font-size: 0.875rem;
  line-height: 1;
}

.chip-remove-icon:focus {
  outline: 2px solid #222222;
  outline-offset: 2px;
}

.chip.disabled {
  background-color: #e9ecef;
  border-color: #c0c0bc;
  color: #6c757d;
  opacity: 0.6;
  cursor: not-allowed;
}

.chip.disabled .chip-remove-icon,
.chip.disabled .chip-quantity {
  cursor: not-allowed;
  opacity: 0.6;
  background-color: #c0c0bc;
  color: #6c757d;
}

/* Color variations based on colorNumber */
.chip-filled.color-1 {
  background-color: #2d6e6d;
}
.chip-filled.color-2 {
  background-color: #256b64;
}
.chip-filled.color-3 {
  background-color: #1a535c;
}
.chip-filled.color-4 {
  background-color: #0f3b54;
}
.chip-filled.color-5 {
  background-color: #05234c;
}
</style>
